var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.75,
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2502 8.45801C20.0648 8.45801 15.8492 12.6736 15.8492 17.859C15.8492 22.9455 19.8273 27.0622 25.0127 27.2403C25.1711 27.2205 25.3294 27.2205 25.4482 27.2403C25.4877 27.2403 25.5075 27.2403 25.5471 27.2403C25.5669 27.2403 25.5669 27.2403 25.5867 27.2403C30.6534 27.0622 34.6315 22.9455 34.6513 17.859C34.6513 12.6736 30.4357 8.45801 25.2502 8.45801Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3044 32.5051C29.7825 28.8238 20.7773 28.8238 15.2159 32.5051C12.7023 34.1874 11.3169 36.4634 11.3169 38.8978C11.3169 41.3322 12.7023 43.5884 15.1961 45.2509C17.9669 47.1113 21.6086 48.0415 25.2502 48.0415C28.8919 48.0415 32.5336 47.1113 35.3044 45.2509C37.7982 43.5686 39.1836 41.3124 39.1836 38.8582C39.1638 36.4238 37.7982 34.1676 35.3044 32.5051Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8a32dc7752b989b3f0289c7d323ab590.svg";
export { ForwardRef as ReactComponent };